import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import { FavoritesProvider } from './context/FavoritesContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/App.css';

// Lazy load pages for better performance (248 KiB savings)
const Feed = lazy(() => import('./pages/Feed'));
const PaperDetail = lazy(() => import('./pages/PaperDetail'));
const Favorites = lazy(() => import('./pages/Favorites'));
const Patterns = lazy(() => import('./pages/Patterns'));
const PatternDetail = lazy(() => import('./pages/PatternDetail'));
const About = lazy(() => import('./pages/About'));

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-64">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white mx-auto mb-4"></div>
      <p className="text-gray-600 dark:text-gray-400">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ThemeProvider>
          <FavoritesProvider>
            <div className="App bg-gray-50 dark:bg-gray-900 min-h-screen flex flex-col transition-colors duration-300">
              <Header />
              <main className="flex-1">
                <ErrorBoundary>
                  <Suspense fallback={<PageLoader />}>
                    <Routes>
                      <Route path="/" element={<ErrorBoundary><Feed /></ErrorBoundary>} />
                      <Route path="/paper/:id" element={<ErrorBoundary><PaperDetail key={window.location.pathname} /></ErrorBoundary>} />
                      <Route path="/favorites" element={<ErrorBoundary><Favorites /></ErrorBoundary>} />
                      <Route path="/patterns" element={<ErrorBoundary><Patterns /></ErrorBoundary>} />
                      <Route path="/patterns/:patternId" element={<ErrorBoundary><PatternDetail /></ErrorBoundary>} />
                      <Route path="/about" element={<ErrorBoundary><About /></ErrorBoundary>} />
                      <Route path="*" element={<ErrorBoundary><Feed /></ErrorBoundary>} />
                    </Routes>
                  </Suspense>
                </ErrorBoundary>
              </main>
              <Footer />
            </div>
          </FavoritesProvider>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;